


export const BLOG_CATEGORY_TAGS = {
    GET_BLOG_CATEGORIES: "GetBlogCategories",
} as const;
